import { takeLatest, put, all, call } from 'redux-saga/effects';

import DemandCollectionActionTypes from './demand-collection-report.types';

import { DemandCollectionListGet } from './demand-collection-report.service';

import {
	getDemandCollectionDetailsSuccess,
	getDemandCollectionDetailsFailure,
	getDemandCollectionDetailsResponseChanged,
} from './demand-collection-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** ***************** GET DEMAND COLLECTION LIST START *********************** */
export function* getDemandCollectionList({ payload }: any) {
	try {
		const key = 'DemandCollectionKey';
		const {
			companyID,
			userID,
			userName,
			centerID,
			officerID,
			branchID,
			groupID,
			funderID,
			loanType,
			databaseName,
			fromDate,
			toDate,
			userLevel,
			isThrift,
			isTenureClosedArrearsinDemandCollectionReport,
			isActiveLoanArrearsinDemandCollectionReport,
			viewType,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			UserRole: userName,
			LocationID: centerID,
			OfficerID: officerID,
			BranchID: branchID,
			GroupID: groupID,
			FunderID: funderID,
			LoanType: loanType,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			UserLevel: userLevel,
			IsThriftExist: isThrift,
			IsTenureClosedODLoans: isTenureClosedArrearsinDemandCollectionReport,
			IsActiveLoanArrears: isActiveLoanArrearsinDemandCollectionReport,
			SearchByViewType: viewType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(DemandCollectionListGet, encodeData, payload.serviceName);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDemandCollectionDetailsFailure(responseData.data));
		} else {
			yield put(getDemandCollectionDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDemandCollectionDetailsFailure(error));
	}
}

export function* resetGetDemandCollectionListResponse() {
	yield put(getDemandCollectionDetailsResponseChanged());
}

export function* onGetDemandCollectionListDetails() {
	yield takeLatest(
		DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_START,
		getDemandCollectionList,
	);
}

export function* onGetDemandCollectionListResponseReset() {
	yield takeLatest(
		DemandCollectionActionTypes.GET_DEMAND_COLLECTION_LIST_RESPONSE_RESET,
		resetGetDemandCollectionListResponse,
	);
}
/** ***************** GET DEMAND COLLECTION LIST END *********************** */

export function* reportDemandCollectionSaga() {
	yield all([
		call(onGetDemandCollectionListDetails),
		call(onGetDemandCollectionListResponseReset),
	]);
}
